import api from "shared/api";
import { withToast } from "shared/utils";
import i18n from "shared/i18n";
import { ROLES } from "shared/config";
import { BaseApiService } from "shared/api";

class TravelLinesService extends BaseApiService {
  async saveTravelLines(requestId, travelLines) {
    return await withToast(
      () =>
        api.post(this.ENDPOINTS.travel_line.crud, {
          user_role: ROLES.USER,
          application_id: requestId,
          travel_intervals: travelLines,
        }),
      {
        onSuccess: i18n.t("toasts.saved_travel_plan", {
          ns: "Request",
        }),
      }
    ).then((response) => response.data);
  }
  async deleteTravelLine(requestId, traveLineId) {
    return await withToast(() =>
      api.post(this.ENDPOINTS.travel_line.crud, {
        user_role: ROLES.USER,
        application_id: requestId,
        travel_intervals: [
          {
            id: traveLineId,
            delete: true,
          },
        ],
      })
    );
  }
}
export default new TravelLinesService();
